import React from 'react';

const MiniLoader = () => <span className="mini-loader" />;

export default MiniLoader;
